<template>
  <div>
    <h1>{{ msg }}</h1>
    <TrackActivity></TrackActivity>
  </div>
</template>

<script>
import Vue from 'vue'
import DataMain from '@/data/dataMain'
import Activities from '@/components/activities/Activities'
import Track from '@/components/activities/TrackActivity'
import {store} from '@/store'
import Dates from '@/mixins/Dates.js'
import { format as dateFnsformat } from 'date-fns'

Vue.use(Dates)

export default {
  name: 'Home',
  components: {
    'Activities': Activities,
    'TrackActivity': Track
  },
  data () {
    return {
      msg: 'Everyday. Do your thing(s)',
      key: null
    }
  },

  async created () {
    if (!this.$parent.key) {
      this.$router.push('/login')
    } else {
      let da = new Date()
      da = dateFnsformat(da, 'YYYY-MM-DD')
      store.commit('setDate', {
        value: da
      })
      this.key = this.$parent.key
      DataMain.getActivities()
      DataMain.getMonth(store.state.activeDate)
    }
  },
  mounted () {

  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/Home.vue